module.exports = __webpack_public_path__ + "static/media/BGmifa.ceff94ee.jpg";